import { Scene } from "phaser";
import { GButton } from "../gameobjects/GButton";
import { TicketsList } from "../gameobjects/TicketsList";
import { unixToDate, getCurrentDraw  } from '../utils';



const COLOR_DARK = 0x212121;


export class MyTicketsScene extends Scene {
    
    constructor() {
        super("MyTicketsScene");
    }

    init(data) {
       
    }


    create(){

         //this.background = "#ccc"
         const storedParamsJSON = localStorage.getItem('gameParams');
         const storedParams = JSON.parse(storedParamsJSON) || {};
 
         const gamecode = storedParams['gamecode'] || import.meta.env.VITE_GAME_CODE;
         this.updateDrawCall(gamecode);

        //console.log("myticket:: CREATE")
        this.numberGrid = [];
        
        this.title = this.add.text(this.scale.width/2, (62 +16 + 24 ) *2, `MY TICKETS`,  { fontFamily: 'Oswald', fontSize: 48, color: '#ffffff' }).setOrigin(0.5);
        this.title.setFontStyle('700')

        const ButtonBack = new GButton(this, this.scale.width/2-330, (62 +16 + 24 ) *2, {
            texturePack: "pack", 
            idleTexture: 'arrow back_ios.png',
            clickedTexture: 'arrow back_ios.png',
            disabledTexture: 'arrow back_ios.png',
            onClick: () => {
                this.scene.start("MenuScene");
             }
        });
        ButtonBack.setScale(0.85);


        this.currentDrawInfo = this.registry.get('currentDraw');
        this.itemList = this.currentDrawInfo.tickets;

        const containerY = (62  +16 + 28 +24) *2;

        this.TicketsHeader = this.add.nineslice(this.scale.width/2,  containerY + 52, 'pack', 'header-main.png', 343*2, 104, 32, 32);



        this.drawDateText = this.add.text(this.scale.width/2-319,  containerY +52, `DRAW DATE` ,  { fontFamily: 'Oswald', fontSize: 26, color: '#ffffff' }).setOrigin(0,0.5);
        this.drawDateText.setFontStyle('700')


        this.DrawDate = unixToDate( this.registry.get('drawdate'));

        this.drawDateDate = this.add.text(this.drawDateText.x + this.drawDateText.width + 16,  containerY + 50, this.DrawDate ,  { fontFamily: 'Oswald', fontSize: 34, color: '#ffffff' }).setOrigin(0, 0.5);
        this.drawDateDate.setFontStyle('700')


        this.drawNumber = this.add.text(this.scale.width/2+319,  containerY + 50, this.currentDrawInfo.draw_date_id ,  { fontFamily: 'Oswald', fontSize: 34, color: '#ffffff' }).setOrigin(1,0.5);
        this.drawNumber.setFontStyle('700')


        this.drawNumberText = this.add.text( this.drawNumber.x - this.drawNumber.width - 16 ,  containerY +52, `DRAW NO.` ,  { fontFamily: 'Oswald', fontSize: 26, color: '#ffffff' }).setOrigin(1,0.5);
        this.drawNumberText.setFontStyle('700')


        this.noTicketsText = this.add.text(this.scale.width/2, containerY + 104 + 93, `NO TICKETS YET...` ,  { fontFamily: 'Oswald', fontSize: 26, color: '#ffffff' }).setOrigin(0.5);
        this.noTicketsText.setFontStyle('700')

        this.noTicketsText.setVisible(false);

        const containerHeight = 460*2

        this.boxHight = this.scale.height/2;

        if(this.itemList.length == 0){
            this.boxHight = 186;
            this.noTicketsText.setVisible(true);
        }

        this.boxGraphics = this.add.graphics();

        this.boxGraphics.fillStyle(0x212121, 1);

        // //  Using an object to define a different radius per corner
        this.boxGraphics.fillRoundedRect(this.scale.width/2-342, containerY +104, 343*2, this.boxHight, { tl: 0, tr: 0, bl: 32, br: 32 });

        this.panel = this.rexUI.add.scrollablePanel({
            x: this.scale.width/2, y: containerY + 104,
            width:  343*2,
            height: 300,
            originY: 0,

            scrollMode: 0,
            background: this.rexUI.add.roundRectangle({
                color: COLOR_DARK,
                // strokeColor:"#FFFFF",
                radius: { tl: 0, tr: 0, bl: 32, br: 32 }
            }),
            panel: {
                child: this.CreatePanel(this),
                //mask: { padding: 30, },
            },
            space: { left: 20, right: 20, top: 40, bottom: 20, panel: 10}
        })
        .layout()

        this.panel.layout();
        
        this.panel.setVisible(false);

        this.updateTicketList(this.itemList)

        this.panel.layout()


        const ButtonBuyTickets = new GButton(this, this.scale.width/2, this.scale.height - 106, {
            texturePack: "pack", 
            idleTexture: 'Button - Primary - Default.png',
            clickedTexture: 'Button - Primary - Clicked.png',
            disabledTexture: 'Button - Primary - Disabled.png',
            text: {
                value:'BUY TICKET',
                style:  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }
            },
            nineslice: {

            },
            onClick: () => {
                //console.log('Button ButtonBuyTickets!');
                //this.scene.stop("MyTicketsScene")
                this.scene.start("BuyTicketScene")
             }
        });        

        this.noTicketsText.setToTop()

    }

    CreatePanel(scene) {
        var panel = scene.rexUI.add.sizer({
            orientation: 'y',
            space: { top: 0, bottom: 20 }
        })
    
        return panel;
    }

    async updateDrawCall(gamecode) {
        const response = await getCurrentDraw(gamecode); 

        if(response.status !== 200 ){
            this.scene.start("ErrorScene", {message: "No Player Information"});
            return;
        }

        //console.log("myticket:: response from CURRENT")
        this.currentDrawInfo  = response.data
        this.registry.set('my-tickets', this.currentDrawInfo.tickets);
        this.registry.set('currentDraw', this.currentDrawInfo);

        if (this.currentDrawInfo.tickets.length > 0){
            this.noTicketsText.setVisible(false);
        }
        this.updateTicketList(this.currentDrawInfo.tickets)
    }


    updateTicketList(itemList){
        
        try {
            this.panel.getElement('panel').removeAll(true);    
        } catch (error) {
            console.log(error)
        }
        if(itemList.length > 0){
            this.panel.setVisible(true);
            this.panel.setMinSize(this.panel.width, 394*2).layout();
        }
        

        
        for (let index = 0; index < itemList.length; index++) {
           const element = itemList[index];
                      
           var lastBoxY = 360;
           this.currentBound = 20
       
           this.numberGrid[index] = new TicketsList(this, 0 , 0, {numbersArray: itemList[index], ticketNumber: index });

           const bounds = this.numberGrid[index].getBounds()
            
           lastBoxY = bounds.height + bounds.y + 50
            
           this.currentBound = bounds.height;
        
           this.panel
           .getElement('panel')
           .add(
                this.numberGrid[index],
                {
                    proportion: 1,
                    align: 'left',
                    padding: {left: 44, right: 0, top: 0 , bottom: this.currentBound + 36},
                    expand: false,
                    fitRatio: 0,  // true
                    offsetX: 0,
                    //offsetY: lastBoxY,
                }
           );
           this.panel
           .getElement('panel')
           
        }

        this.panel
        .getElement('panel')
        .addSpace().layout()

        //this.panel.setMinSize(this.panel.width, 346*2).layout();

         this.panel.layout()

    }

}